import { Dispatch, SetStateAction } from 'react';
import { PlannerRestoreFromBackupList } from '../planner-restore/planner-restore-list';
import { Button } from '@/components/ui/button';

function BackupListactions({
  data,
  setShowDiff,
  setRestoreDialogData,
}: {
  data: PlannerRestoreFromBackupList;
  setShowDiff: Dispatch<React.SetStateAction<string>>;
  setRestoreDialogData: Dispatch<SetStateAction<PlannerRestoreFromBackupList>>;
}) {
  return (
    <>
      <Button className='mr-2' onClick={() => setShowDiff(data.backupId)}>
        Diff
      </Button>
      <Button onClick={() => setRestoreDialogData(data)}>Restore</Button>
    </>
  );
}

export default BackupListactions;
